import { WordPress } from '../../../../wordpress/wordpress_api'
import { CMSState, Link as LinkType } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { IOWidget, Action, mk_widget } from 'widgets-for-react'
import { PublicSiteState } from '../../../../public_site.main.mod'
import React from 'react'
import { link, linkWrapper, isLinkExternal, isLinkDownload } from '../../../../cms/blocks/utils.gen'
import { optimizeActivate, toRelativeUrl } from '../../../../../helpers'
import { ButtonData } from '../../../../wordpress/types_and_parser/extra_types.mod'
import { getImageAttribute } from '../../../utils/extra_images.mod'
import { Link } from 'react-router-dom'
import i18next from 'i18next'

export type GridHighlightsBlockItem = {
  title: string
  intro: string
  image?: WordPress.MediaResponse
  link?: string
  label?: string
  is_video?: boolean
  has_gradient?: boolean
}

export type GridAttributes = {
  blockName: 'vidda/grid-highlights'
  title: string
  intro: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  blocks: Array<GridHighlightsBlockItem>
}

export interface GridInterface {
  blockName: 'vidda/grid-highlights'
  attrs: GridAttributes
}

export type GridHighlightsBlockProps<extra_images> = GridAttributes

export type GridHighlightsBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

export function GridHighlightsBlock<customBlockData, extra_images>(
  props: GridHighlightsBlockProps<extra_images>,
  options?: { style: GridHighlightsBlockStyle; key?: string }
): (
  s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>
) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    if (s.custom_page_data.v.kind == 'r' && s.custom_page_data.v.v.post.type == 'page' && s.custom_page_data.v.v.post.is_front) {
      optimizeActivate()
    }
    return mk_widget({
      run: (_) => (
        <section className="block block--highlights">
          <div className="block__inner container--xl grid--block">
            <header className="block__header">
              <h2 className="block__title typo--l">{i18next.t("highlights.title")}</h2>
            </header>
            <div className="block__content">
              <ul className="block__grid grid">
                {props.blocks.map((item, index) => {
                  return index == 2 ? (
                    <li
                      className={`grid__item ${item.is_video ? 'grid__item--video' : ''} ${
                        item.has_gradient ? 'grid__item--gradient' : ''
                      }`}
                    >
                      <div className="grid__content">
                        {item.label && <span className="grid__label typo--3xs">{item.label}</span>}
                        {item.title && <h3 className="grid__title typo--3xl">{item.title}</h3>}
                        {item.link && 
                          link(linkWrapper({title:item.title,url:item.link}),
                          { classname: "grid__link" },
                          ''
                          )
                        }
                      </div>
                      {item.image && (
                        <div className="grid__visual fit-object">
                          <img
                            src={getImageAttribute(item.image, 'highlightSecond', 'source_url')}
                            width={690}
                            height={655}
                            alt={item.image.alt_text ? item.image.alt_text : ''}
                          />
                        </div>
                      )}
                    </li>
                  ) : index > 2 ? (
                    <li
                      className={`grid__item ${item.is_video ? 'grid__item--video' : ''} ${
                        item.has_gradient ? 'grid__item--gradient' : ''
                      }`}
                    >
                      <div className="grid__content">
                        {item.title && <h3 className="grid__title">{item.title}</h3>}
                        {item.link && 
                          link(linkWrapper({title:item.title,url:item.link}),
                          { classname: "grid__link" },
                          ''
                          )
                        }
                      </div>
                      {item.image && (
                        <div className="grid__visual fit-object">
                          <img
                            src={getImageAttribute(item.image, 'highlightThird', 'source_url')}
                            width={308}
                            height={440}
                            alt={item.image.alt_text ? item.image.alt_text : ''}
                          />
                          {item.label && <span className="grid__label typo--3xs">{item.label}</span>}
                        </div>
                      )}
                    </li>
                  ) : (
                    <li
                      className={`grid__item ${item.is_video ? 'grid__item--video' : ''} ${
                        item.has_gradient ? 'grid__item--gradient' : ''
                      }`}
                    >
                      <div className="grid__content">
                        {item.title && <h3 className="grid__title">{item.title}</h3>}
                        {item.link && 
                          link(linkWrapper({title:item.title,url:item.link}),
                          { classname: "grid__link" },
                          ''
                          )
                        }
                      </div>
                      {item.image && (
                        <div className="grid__visual fit-object">
                          <img
                            src={getImageAttribute(item.image, 'highlightFirst', 'source_url')}
                            width={320}
                            height={320}
                            alt={item.image.alt_text ? item.image.alt_text : ''}
                          />
                          {item.label && <span className="grid__label typo--3xs">{item.label}</span>}
                        </div>
                      )}
                    </li>
                  )
                })}
              </ul>
            </div>
            <footer className="block__footer">
              <p className="block__text">{i18next.t("highlights.footer_copy")}</p>
              <a className="button button--primary" href={i18next.t("highlights.link_url")}>
              {i18next.t("highlights.link_copy")}
              </a>
            </footer>
          </div>
        </section>
      ),
    })
  }
}
